/* =========================================================
   AIELLO Projects — interactions
   - Grid: filtros pills + URL sync + contador + lightbox carrossel
   - Pagina individual: thumbs + lightbox da galeria
   ========================================================= */

(function () {
  'use strict';

  /* ===========================================================
     Utilitarios
     =========================================================== */
  function $(selector, ctx) { return (ctx || document).querySelector(selector); }
  function $$(selector, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(selector)); }

  function getQuery(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }
  function setQuery(name, value) {
    var params = new URLSearchParams(window.location.search);
    if (value && value !== 'all') {
      params.set(name, value);
    } else {
      params.delete(name);
    }
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  function trapFocus(modal) {
    var focusables = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', modal)
      .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!focusables.length) return function () {};
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    modal.addEventListener('keydown', handler);
    return function () { modal.removeEventListener('keydown', handler); };
  }

  /* ===========================================================
     GRID — filtros + lightbox compartilhado
     =========================================================== */
  function initGrid(section) {
    if (section.__aielloPGInit) return;
    section.__aielloPGInit = true;

    var pills = $$('[data-aiello-filter]', section);
    var cards = $$('[data-aiello-card]', section);
    var countEl = $('[data-aiello-count]', section);

    /* ---------- Filtros ---------- */
    function applyFilter(env) {
      var visible = 0;
      cards.forEach(function (card) {
        var match = (env === 'all') || (card.getAttribute('data-env') === env);
        card.classList.toggle('is-hidden', !match);
        if (match) visible++;
      });
      if (countEl) countEl.textContent = visible;
      pills.forEach(function (p) {
        var active = p.getAttribute('data-aiello-filter') === env;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var env = pill.getAttribute('data-aiello-filter');
        applyFilter(env);
        setQuery('env', env);
      });
    });

    // Estado inicial via URL (?env=Residencial)
    var initialEnv = getQuery('env');
    if (initialEnv) {
      var match = pills.some(function (p) { return p.getAttribute('data-aiello-filter') === initialEnv; });
      if (match) applyFilter(initialEnv);
    }

    /* ---------- Lightbox ---------- */
    var lightbox = $('[data-aiello-lightbox]', section);
    if (!lightbox) return;

    var lbSlides = $('[data-aiello-lb-slides]', lightbox);
    var lbDots = $('[data-aiello-lb-dots]', lightbox);
    var lbEnv = $('[data-aiello-lb-env]', lightbox);
    var lbTitle = $('[data-aiello-lb-title]', lightbox);
    var lbLocation = $('[data-aiello-lb-location]', lightbox);
    var lbArchitect = $('[data-aiello-lb-architect]', lightbox);
    var lbDesc = $('[data-aiello-lb-desc]', lightbox);
    var lbModelsWrap = $('[data-aiello-lb-models-wrap]', lightbox);
    var lbModels = $('[data-aiello-lb-models]', lightbox);
    var lbClose = $('[data-aiello-lb-close]', lightbox);
    var lbPrev = $('[data-aiello-lb-prev]', lightbox);
    var lbNext = $('[data-aiello-lb-next]', lightbox);

    var currentIdx = 0;
    var currentGallery = [];
    var releaseFocusTrap = null;
    var lastTrigger = null;

    function renderSlide(idx) {
      currentIdx = idx;
      $$('.aiello-pg__lb-slide', lbSlides).forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      $$('.aiello-pg__lb-dot', lbDots).forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    function openLightbox(card) {
      lastTrigger = card.querySelector('[data-aiello-modal-trigger]');

      var title = card.getAttribute('data-title') || '';
      var env = card.getAttribute('data-env') || '';
      var location = card.getAttribute('data-location') || '';
      var architect = card.getAttribute('data-architect') || '';
      var desc = card.getAttribute('data-desc') || '';
      var url = card.getAttribute('data-url') || '#';
      var gallery = (card.getAttribute('data-gallery') || '').split('||').filter(Boolean);
      var modelsRaw = (card.getAttribute('data-models') || '').split('||').filter(Boolean);

      currentGallery = gallery;

      lbTitle.textContent = title;
      lbEnv.textContent = env;
      lbLocation.textContent = location;
      lbArchitect.textContent = architect ? 'Arquiteto: ' + architect : '';
      lbDesc.textContent = desc;

      // Slides
      lbSlides.innerHTML = '';
      gallery.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'aiello-pg__lb-slide' + (i === 0 ? ' is-active' : '');
        var img = document.createElement('img');
        img.src = src;
        img.alt = title;
        img.loading = i === 0 ? 'eager' : 'lazy';
        slide.appendChild(img);
        lbSlides.appendChild(slide);
      });

      // Dots
      lbDots.innerHTML = '';
      if (gallery.length > 1) {
        gallery.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'aiello-pg__lb-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Ir para imagem ' + (i + 1));
          dot.addEventListener('click', function () { renderSlide(i); });
          lbDots.appendChild(dot);
        });
      }

      // Mostra prev/next so se houver mais de 1
      lbPrev.style.display = gallery.length > 1 ? '' : 'none';
      lbNext.style.display = gallery.length > 1 ? '' : 'none';

      // Modelos
      if (modelsRaw.length > 0) {
        lbModels.innerHTML = '';
        modelsRaw.forEach(function (m) {
          var parts = m.split('::');
          if (parts.length < 2) return;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = parts[1];
          a.textContent = parts[0];
          li.appendChild(a);
          lbModels.appendChild(li);
        });
        lbModelsWrap.hidden = false;
      } else {
        lbModelsWrap.hidden = true;
      }

      currentIdx = 0;
      lightbox.hidden = false;
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      releaseFocusTrap = trapFocus(lightbox);
      setTimeout(function () { lbClose.focus(); }, 50);
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (releaseFocusTrap) releaseFocusTrap();
      if (lastTrigger) lastTrigger.focus();
    }

    function nextSlide() {
      if (!currentGallery.length) return;
      renderSlide((currentIdx + 1) % currentGallery.length);
    }
    function prevSlide() {
      if (!currentGallery.length) return;
      renderSlide((currentIdx - 1 + currentGallery.length) % currentGallery.length);
    }

    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-aiello-modal-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(card);
      });
    });

    lbClose.addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', prevSlide);
    lbNext.addEventListener('click', nextSlide);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    });
  }

  /* ===========================================================
     GALLERY (pagina individual)
     =========================================================== */
  function initGallery(section) {
    if (section.__aielloPGalInit) return;
    section.__aielloPGalInit = true;

    var main = $('[data-aiello-pgal-main]', section);
    var mainImg = main ? main.querySelector('img') : null;
    var thumbs = $$('[data-aiello-pgal-thumb]', section);
    var zoomBtn = $('[data-aiello-pgal-zoom]', section);
    var lb = $('[data-aiello-pgal-lb]', section);
    var lbImg = $('[data-aiello-pgal-lb-img]', section);
    var lbClose = $('[data-aiello-pgal-lb-close]', section);
    var lbPrev = $('[data-aiello-pgal-lb-prev]', section);
    var lbNext = $('[data-aiello-pgal-lb-next]', section);

    var images = thumbs.map(function (t) {
      return { src: t.getAttribute('data-src'), alt: t.getAttribute('data-alt') || '' };
    });

    // Fallback: se nao houver thumbs, monta lista so com a main
    if (!images.length && mainImg) {
      images = [{ src: mainImg.currentSrc || mainImg.src, alt: mainImg.alt }];
    }

    var currentIdx = 0;
    var releaseFocusTrap = null;
    var lastTrigger = null;

    function setActiveThumb(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    function setMain(idx) {
      if (!mainImg || !images[idx]) return;
      currentIdx = idx;
      mainImg.src = images[idx].src;
      mainImg.alt = images[idx].alt;
      setActiveThumb(idx);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setMain(i); });
    });

    /* ---------- Lightbox ---------- */
    function openLb(idx) {
      if (!lb) return;
      lastTrigger = document.activeElement;
      currentIdx = idx;
      lbImg.src = images[idx].src;
      lbImg.alt = images[idx].alt;
      lb.hidden = false;
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      releaseFocusTrap = trapFocus(lb);
      lbPrev.style.display = images.length > 1 ? '' : 'none';
      lbNext.style.display = images.length > 1 ? '' : 'none';
      setTimeout(function () { lbClose.focus(); }, 50);
    }
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('is-open');
      lb.hidden = true;
      document.body.style.overflow = '';
      if (releaseFocusTrap) releaseFocusTrap();
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }
    function nextLb() {
      var i = (currentIdx + 1) % images.length;
      lbImg.src = images[i].src;
      lbImg.alt = images[i].alt;
      currentIdx = i;
    }
    function prevLb() {
      var i = (currentIdx - 1 + images.length) % images.length;
      lbImg.src = images[i].src;
      lbImg.alt = images[i].alt;
      currentIdx = i;
    }

    if (main) {
      main.addEventListener('click', function () { openLb(currentIdx); });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(currentIdx); }
      });
    }
    if (zoomBtn) zoomBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      openLb(currentIdx);
    });
    if (lbClose) lbClose.addEventListener('click', closeLb);
    if (lbPrev) lbPrev.addEventListener('click', prevLb);
    if (lbNext) lbNext.addEventListener('click', nextLb);
    if (lb) lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') nextLb();
      if (e.key === 'ArrowLeft') prevLb();
    });
  }

  /* ===========================================================
     Bootstrap
     =========================================================== */
  function bootstrap() {
    $$('[data-aiello-projects]').forEach(initGrid);
    $$('[data-aiello-pgal]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init em Theme Editor (Shopify dispara shopify:section:load)
  document.addEventListener('shopify:section:load', bootstrap);
})();

